import { LabelProps } from "@ptomasroos/react-native-multi-slider";
import React, { memo } from "react";

import LinearMultiSlider from "@/components/organisms/LinearMultiSlider";
import PowerSlider from "@/components/organisms/PowerSlider";
/**
 *
 */
interface MultiSliderViewProps {
  value: number[];
  onChange: (value: [number, number]) => void;
  minValue: number;
  maxValue: number;
  step?: number;
  width?: number;
  renderCustomLabel?: React.ComponentType<LabelProps>;
  useLogScale?: boolean;
}

/**
 * Presentational component that renders either PowerSlider or LinearMultiSlider.
 * Delegates to appropriate slider implementation based on scale type.
 * @param root0 - Component props
 * @param root0.useLogScale - Whether to use logarithmic PowerSlider (true) or linear slider (false)
 */
const MultiSliderView: React.FC<MultiSliderViewProps> = ({
  useLogScale,
  ...props
}) =>
  useLogScale ? <PowerSlider {...props} /> : <LinearMultiSlider {...props} />;

MultiSliderView.displayName = "MultiSliderView";

export default memo(MultiSliderView);
